module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0104.jpg?v=47d0a86c";